import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PopperLabel = ({
  title = "전체보기",
  active = true,
  onClick,
  type = "advertiser",
  num = 0,
}) => {
  return (
    <>
      {active ? (
        <Box
          sx={{
            height: 35,
            display: "flex",
            alignItems: "center",
            backgroundColor: "#F6F6F8",
            borderRadius: "6px",
            cursor: "pointer",
            pl: 1,
          }}
        >
          <Typography
            variant="body"
            component="div"
            fontWeight={500}
            color={"grey.900"}
          >
            {title}
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            height: 35,
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => onClick(num, type)}
        >
          <Typography
            variant="body"
            component="div"
            fontWeight={500}
            color={"grey.800"}
          >
            {title}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default PopperLabel;
